module.exports = __webpack_public_path__ + "img/782.bab043de.png";